document.addEventListener('DOMContentLoaded', function () {
 
setTimeout(() => {
  const Relatedswiper = new Swiper('.related-products .related-collection', {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 16,
    breakpoints: {
      749: {
        slidesPerView: 2.2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    }
  });
}, "1000");
  
  
});
